import React from "react";

export function Privacy() {
  return (
    <div
      className="container py-4"
      style={{ maxWidth: "80ch", margin: "0 auto" }}
    >
      <h2>Privacy Policy</h2>
      <p className="text-muted">
        We respect your privacy and strive to keep your data footprint minimal.
      </p>
      <section className="mb-3">
        <h5>What We Collect</h5>
        <p>
          This site is an informational resource and does not require you to create an
          account. We do not store personal information about you on our servers.
        </p>
      </section>
      <section className="mb-3">
        <h5>Analytics & Cookies</h5>
        <p>
          If analytics or performance monitoring is enabled, it is used only to
          understand aggregate usage trends. We avoid tracking technologies that
          identify individual visitors whenever possible.
        </p>
      </section>
      <section className="mb-3">
        <h5>Third-Party Links</h5>
        <p>
          Some tools link to external resources. Their privacy practices are outside
          our control, so review their policies before providing any information.
        </p>
      </section>
      <p className="small text-muted mb-0">
        Last updated: {new Date().getFullYear()}.
      </p>
    </div>
  );
}
